import { useContext } from 'react';
import { Table, TableBody, TableCell, TableHead, TableRow, TableFooter, Typography } from '@material-ui/core';
import { UserGroupsContext } from '../UserGroupsContext';
import { DeleteIconButton, EditIconButton } from 'components';


let Results = () => {
    let service = useContext(UserGroupsContext);

    return (
        <Table>
            <TableHead>
                <TableRow>
                    <TableCell>Code</TableCell>
                    <TableCell>Description</TableCell>
                    <TableCell />
                </TableRow>
            </TableHead>
            <TableBody>
                {service.userGroups.map((type, index) =>
                    <TableRow hover key={index}>
                        <TableCell>{type.code}</TableCell>
                        <TableCell>{type.description}</TableCell>
                        <TableCell align="right">
                            <EditIconButton link={`/admin/usergroup/${type.id}`} />
                            <DeleteIconButton onClick={() => service.deleteUserGroup(type.id)} stopPropagation />
                        </TableCell>
                    </TableRow>
                )}
            </TableBody>
            {service.userGroups.length === 0 &&
                <TableFooter>
                    <TableRow>
                        <TableCell colSpan={3}>
                            <Typography variant="subtitle2">No user groups found</Typography>
                        </TableCell>
                    </TableRow>
                </TableFooter>
            }
        </Table>
    );
}

export default Results;